import {
  INVENTORY_TOTAL_VALUE_REQUEST,
  INVENTORY_TOTAL_VALUE_SUCCESS,
  INVENTORY_TOTAL_VALUE_FAIL,
  WAREHOUSE_LIST_REQUEST,
  WAREHOUSE_LIST_SUCCESS,
  WAREHOUSE_LIST_FAIL,
  INVENTORY_ALERTS_REQUEST,
  INVENTORY_ALERTS_SUCCESS,
  INVENTORY_ALERTS_FAIL,
  PRODUCT_INVENTORY_SUMMARY_REQUEST,
  PRODUCT_INVENTORY_SUMMARY_SUCCESS,
  PRODUCT_INVENTORY_SUMMARY_FAIL,
  WAREHOUSE_PRODUCT_DETAILS_REQUEST,
  WAREHOUSE_PRODUCT_DETAILS_SUCCESS,
  WAREHOUSE_PRODUCT_DETAILS_FAIL,
  INVENTORY_TRANSACTION_REQUEST,
  INVENTORY_TRANSACTION_SUCCESS,
  INVENTORY_TRANSACTION_FAIL,
  INVENTORY_TRANSACTIONS_REQUEST,
  INVENTORY_TRANSACTIONS_SUCCESS,
  INVENTORY_TRANSACTIONS_FAIL
} from '../constants/inventoryConstants';

// 库存总价值 reducer
export const inventoryTotalValueReducer = (state = { totalValues: [] }, action) => {
  switch (action.type) {
    case INVENTORY_TOTAL_VALUE_REQUEST:
      return { ...state, loading: true };
    case INVENTORY_TOTAL_VALUE_SUCCESS:
      return { loading: false, totalValues: action.payload };
    case INVENTORY_TOTAL_VALUE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};


// 仓库列表 reducer
export const warehouseListReducer = (state = { warehouses: [] }, action) => {
  switch (action.type) {
    case WAREHOUSE_LIST_REQUEST:
      return { ...state, loading: true };
    case WAREHOUSE_LIST_SUCCESS:
      return { loading: false, warehouses: action.payload };
    case WAREHOUSE_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 库存预警 reducer
export const inventoryAlertsReducer = (state = { alerts: [] }, action) => {
  switch (action.type) {
    case INVENTORY_ALERTS_REQUEST:
      return { ...state, loading: true };
    case INVENTORY_ALERTS_SUCCESS:
      return { loading: false, alerts: action.payload };
    case INVENTORY_ALERTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const productInventorySummaryReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_INVENTORY_SUMMARY_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_INVENTORY_SUMMARY_SUCCESS:
      return { loading: false, products: action.payload };
    case PRODUCT_INVENTORY_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 仓库产品详情 reducer
export const warehouseProductDetailsReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case WAREHOUSE_PRODUCT_DETAILS_REQUEST:
      return { ...state, loading: true };
    case WAREHOUSE_PRODUCT_DETAILS_SUCCESS:
      return { loading: false, products: action.payload };
    case WAREHOUSE_PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const inventoryTransactionReducer = (state = {}, action) => {
  switch (action.type) {
    case INVENTORY_TRANSACTION_REQUEST:
      return { ...state, loading: true };
    case INVENTORY_TRANSACTION_SUCCESS:
      return { loading: false, success: true, transaction: action.payload };
    case INVENTORY_TRANSACTION_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// 交易列表reducer
export const inventoryTransactionsReducer = (state = { transactions: [] }, action) => {
  switch (action.type) {
    case INVENTORY_TRANSACTIONS_REQUEST:
      return { ...state, loading: true };
    case INVENTORY_TRANSACTIONS_SUCCESS:
      return { 
        loading: false, 
        transactions: action.payload.transactions || action.payload,
        pagination: action.payload.pagination 
      };
    case INVENTORY_TRANSACTIONS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};